import factory from './icon';
import Svg12x12 from './glyphs/Logout_12x12.svg'; 

export const Logout12x12 = factory(Svg12x12, 12, 12);
